import type { EntityConfig } from '../types'

export const refundEntity: EntityConfig = {
  id: 'refund',
  displayName: 'Refund',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'pending', label: 'Pending Approval' },
      { value: 'succeeded', label: 'Refunded' },
      { value: 'failed', label: 'Refund Failed' },
      { value: 'canceled', label: 'Refund Canceled' },
    ],
    options: [
      { value: 'pending', label: 'Pending Approval', color: 'warning' },
      { value: 'refund_requested', label: 'Pending Approval', color: 'warning' },
      { value: 'refund_processing', label: 'Processing', color: 'pending' },
      { value: 'sending_for_refund', label: 'Processing', color: 'pending' },
      { value: 'succeeded', label: 'Refunded', color: 'success' },
      { value: 'refunded', label: 'Refunded', color: 'success' },
      { value: 'partially_refunded', label: 'Partially Refunded', color: 'warning' },
      { value: 'failed', label: 'Refund Failed', color: 'error' },
      { value: 'refund_failed', label: 'Refund Failed', color: 'error' },
      { value: 'refund_declined', label: 'Refund Declined', color: 'error' },
      { value: 'refund_blocked', label: 'Refund Blocked', color: 'error' },
      { value: 'refund_denied', label: 'Refund Denied', color: 'error' },
      { value: 'canceled', label: 'Refund Canceled', color: 'neutral' },
    ],
    mappings: {
      all: ['pending', 'refund_requested', 'refund_processing', 'sending_for_refund', 'succeeded', 'refunded', 'partially_refunded', 'failed', 'refund_failed', 'refund_declined', 'refund_blocked', 'refund_denied', 'canceled'],
      pending: ['pending', 'refund_requested', 'refund_processing', 'sending_for_refund'],
      succeeded: ['succeeded', 'refunded', 'partially_refunded'],
      failed: ['failed', 'refund_failed', 'refund_declined', 'refund_blocked', 'refund_denied'],
      canceled: ['canceled'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    amount: { type: 'amount', urlKey: 'amount' },
    reason: { type: 'string_array', urlKey: 'reason' },
    paymentMethod: { type: 'string_array', urlKey: 'paymentMethod' },
    customerName: { type: 'search', urlKey: 'customerName' },
    paymentId: { type: 'search', urlKey: 'paymentId' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'amount',
    'dateRange',
  ]
}
